import {TheCryptGameAssets} from "../TheCryptGameAssets";
import {BitmapTextStyleOptions} from "../components/BasicBitmapCountUp";

export class TheCryptFontConfig {
    public static NUDGE_WILD_MULTIPLIER_STYLE:BitmapTextStyleOptions = {
        fontName : TheCryptGameAssets.BITMAP_FONT_NUDGE_WILD_MULTIPLIER,
        fontSize : 54
    }

    public static M1_MULTIPLIER_STYLE:BitmapTextStyleOptions = {
        fontName : TheCryptGameAssets.BITMAP_FONT_METER_M1,
        fontSize : 34
    }
}